import {
	FaFile,
	FaFileCode,
	FaFileCsv,
	FaFileExcel,
	FaFileImage,
	FaFileLines,
	FaFilePdf,
	FaFilePowerpoint,
	FaFileWord,
	FaFileZipper,
} from "react-icons/fa6";

export const FileIcon = ({ extension }: { extension: string }) => {
	switch (extension.toUpperCase()) {
		case "PNG":
		case "JPG":
		case "JPEG":
		case "GIF":
			return <FaFileImage className="text-lg text-slate-400" />;
		case "PDF":
			return <FaFilePdf className="text-lg text-slate-400" />;
		case "XLS":
		case "XLSX":
			return <FaFileExcel className="text-lg text-slate-400" />;
		case "CSV":
			return <FaFileCsv className="text-lg text-slate-400" />;
		case "PPT":
		case "PPTX":
			return <FaFilePowerpoint className="text-lg text-slate-400" />;
		case "DOC":
		case "DOCX":
			return <FaFileWord className="text-lg text-slate-400" />;
		case "ZIP":
			return <FaFileZipper className="text-lg text-slate-400" />;
		case "TXT":
			return <FaFileLines className="text-lg text-slate-400" />;
		case "HTML":
		case "HTM":
			return <FaFileCode className="text-lg text-slate-400" />;
		default:
			return <FaFile className="text-lg text-slate-400" />;
	}
};
